export default __webpack_public_path__ + "static/img-escolar-500x325-d1ca710030affc4fbd0aee4ca5e214f8.png";